import { useTheme } from "react-jss";
import { RequiredSpanStyle } from "./requiredSpan.jss";

export const RequiredSpan = () => {
    const theme = useTheme();
    const style = RequiredSpanStyle({ theme });

    return <span className={style.required}>*</span>;
};
